import {
    arrowActiveScale,
    arrowScale,
    dimOpacity,
    edgeActiveWidth,
    edgeBGColor,
    edgeWidth,
    fontColor,
    fontMaxSize,
    fontMinSize,
    nodeActiveBGColor,
    nodeActiveFontSize,
    nodeActiveSize,
    nodeBGColor,
    nodeMaxSize,
    nodeMinSize,
    predecessorsColor,
    successorColor
} from "./style";
import {_delete, get, patch, patchJson} from "../../../lib/axios";
import tinycolor from "tinycolor2";
import store from "../../../redux/store";
import isBeta from "../../../lib/beta";

function is_my_map() {
    let is_my_map = false;
    let userid = store.getState().getIn(['user', 'userid']);
    let members = store.getState().getIn(['map', 'members']);
    if (userid && members) {
        is_my_map = (store.getState().getIn(['map', 'members']).filter(item => item.id === userid)).length > 0
    }
    return is_my_map;
}

function is_login() {
    return store.getState().getIn(['user', 'is_login'])
}

function is_public_write_map() {
    return store.getState().getIn(['map', 'permission']).write_public;
}

function getMaxZIndex() {
    if (!window.zindex) {
        window.zindex = 1;
    }
    return ++window.zindex;
}

function setOpacityElement(target_element, degree) {
    target_element.style('opacity', degree);
}

function setFocus(target_cy, target_element, successorsColor, predecessorsColor, edgeWidth, arrowScale) {
    target_element.style('background-color', nodeActiveBGColor);
    target_element.style('color', fontColor);
    setOpacityElement(target_element, 1);
    target_element.successors().each(
        function (e) {
            if (e.isEdge()) {
                e.style('width', edgeWidth);
                e.style('arrow-scale', arrowScale);
            }
            e.style('color', fontColor);
            e.style('background-color', successorColor);
            e.style('line-color', successorColor);
            e.style('target-arrow-color', successorColor);
            e.style('z-index', getMaxZIndex());
            setOpacityElement(e, 1);
        }
    );
    target_element.predecessors().each(function (e) {
        if (e.isEdge()) {
            e.style('width', edgeWidth);
            e.style('arrow-scale', arrowScale);
        }
        e.style('color', fontColor);
        e.style('background-color', predecessorsColor);
        e.style('line-color', predecessorsColor);
        e.style('target-arrow-color', predecessorsColor);
        e.style('z-index', getMaxZIndex());
        setOpacityElement(e, 1);
    });
    target_element.neighborhood().each(
        function (e) {
            var empDegree = 30;
            e.style('background-color', tinycolor(e.style('background-color')).darken(empDegree).toString());
            e.style('line-color', tinycolor(e.style('line-color')).darken(empDegree).toString());
            e.style('target-arrow-color', tinycolor(e.style('target-arrow-color')).darken(empDegree).toString());
        }
    );
    target_element.style('z-index', getMaxZIndex());
    target_element.style('width', Math.max(parseFloat(target_element.style('width')), nodeActiveSize));
    target_element.style('height', Math.max(parseFloat(target_element.style('height')), nodeActiveSize));
    target_element.style('font-size', Math.max(parseFloat(target_element.style('font-size')), nodeActiveFontSize));
}

function calculateRankRatioForNormalize(target_cy) {
    let ranks = [];
    target_cy.nodes().forEach(function (target) {
        const rank = pageRank.rank(target);
        ranks.push(rank);
    });
    let rankRatio = Math.max.apply(null, ranks) / 100;
    return rankRatio;
}

function setResetFocus(target_cy) {
    let maxSize = 0;
    let rankRatio = calculateRankRatioForNormalize(target_cy);
    target_cy.nodes().forEach(function (target) {
        target.style('background-color', nodeBGColor);
        var rank = pageRank.rank(target);
        var normalizedRank = rank / rankRatio;
        target.style('width', normalizedRank + nodeMinSize);
        target.style('height', normalizedRank + nodeMinSize);
        target.style('font-size', fontMaxSize * rank + fontMinSize);
        target.style('color', fontColor);
        // [node-parent-or] 그룹 선택 시 cy.elements().style('opacity', 0)로 숨긴 요소들이
        // 선택 해제 후에도 opacity 0으로 남아있던 버그 수정 — 리셋 시 opacity도 함께 복원한다.
        target.style('opacity', 1);
    });
    target_cy.edges().forEach(function (target) {
        target.style('line-color', edgeBGColor);
        target.style('target-arrow-color', edgeBGColor);
        target.style('width', edgeWidth);
        target.style('arrow-scale', arrowScale);
        target.style('opacity', 1);
    });

}

// [#149][#151] 노드 선택 시, 선택한 노드가 속한 그룹과 선택한 노드와 엣지로 연결된 노드가 속한 그룹만
// 온전히 보이게 하고 나머지 그룹은 dimOpacity로 흐리게 표시한다.
// [#151] 이전에는 display:'none'으로 완전히 숨겼는데, cytoscape는 display:'none'인 엘리먼트의
// boundingBox()를 빈 값(Infinity)으로 계산하기 때문에 노드를 그 그룹 위로 드래그해서 놓아도
// findGroupToConfirm의 후보 판정에서 항상 제외되어 그룹 편입 기능이 함께 망가지는 문제가 있었다.
function updateGroupVisibility(target_cy, selectedId) {
    const groups = target_cy.nodes(':parent');
    if (!selectedId) {
        groups.style('opacity', 1);
        return;
    }
    const selectedEle = target_cy.$('#' + selectedId);
    if (selectedEle.empty()) {
        groups.style('opacity', 1);
        return;
    }
    const relatedGroupIds = new Set();
    if (selectedEle.isParent()) {
        // 선택된 요소 자체가 그룹(부모 노드)이면 그 그룹도 표시 대상에 포함해야 한다.
        relatedGroupIds.add(selectedEle.id());
    }
    const ownParent = selectedEle.parent();
    if (ownParent.nonempty()) {
        relatedGroupIds.add(ownParent.id());
    }
    selectedEle.connectedEdges().forEach(function (edge) {
        const other = edge.source().id() === selectedEle.id() ? edge.target() : edge.source();
        const otherParent = other.parent();
        if (otherParent.nonempty()) {
            relatedGroupIds.add(otherParent.id());
        }
    });
    groups.forEach(function (group) {
        group.style('opacity', relatedGroupIds.has(group.id()) ? 1 : dimOpacity);
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function applyContextMenu(param, props) {
    cy.cxtmenu({
        selector: 'node',
        commands: function (ele) {
            const commands = [
                {
                    content: '삭제',
                    select: function (ele) {
                        if (is_login()) {
                            if (is_my_map()) {
                                // [#136] 그룹(부모) 노드는 하위 지식까지 지울지 선택할 수 있는
                                // 다이얼로그를 띄운다. 일반 노드는 기존 confirm을 그대로 유지한다.
                                if (ele.isParent()) {
                                    props.open_delete_group(ele.id());
                                    return;
                                }
                                if (window.confirm('really?')) {
                                    _delete(`/api/v1/seomalmap/${param.map_id}/node/?node_id=${ele.id()}`, {}, (result) => {
                                        get(`/api/v1/seomalmap/${param.map_id}/`, {}, (json) => {
                                            props.set(json.data.elements, param.map_id)
                                        });
                                    })
                                }
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }

                    }
                },
                {
                    content: '부모 지식 생성',
                    select: function (ele) {
                        console.log('create parent')
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.open_create_node('PARENT', ele.id(), cy.viewport().pan());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog()
                        }
                    }
                },
                {
                    content: '자식 지식 생성',
                    select: function (ele) {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.open_create_node('CHILD', ele.id(), cy.viewport().pan());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                },
                {
                    content: '편집',
                    select: function (ele) {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.open_edit_node(ele.id(), cy.viewport().pan());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                },
                {
                    content: '부모 지식 연결',
                    select: (ele) => {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.edge_connect_source(ele.id());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                }
            ];
            // [#128] 컴파운드(자식을 가진) 노드는 "지식 그룹"이므로 멤버를 추가하는 메뉴를 보여주고,
            // 일반 노드는 자신을 첫 멤버로 하는 새 지식 그룹을 만드는 메뉴를 보여준다.
            if (ele.isParent()) {
                commands.push({
                    content: '그룹에 지식 추가',
                    select: (ele) => {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.group_add_open(ele.id());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                });
            } else {
                commands.push({
                    content: '지식 그룹 생성',
                    select: (ele) => {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                props.open_create_group(ele.id(), cy.viewport().pan());
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                });
            }
            // [#134] 그룹(부모 노드)에 소속된 노드에게만 소속 해제 메뉴를 보여준다.
            if (ele.parent().nonempty()) {
                commands.push({
                    content: '그룹에서 빼기',
                    select: (ele) => {
                        if (is_login()) {
                            if (is_my_map() || is_public_write_map()) {
                                patchJson(`/api/v1/node/${ele.id().substr(1)}/`, {
                                    parent: null
                                }, () => {
                                    get(`/api/v1/seomalmap/${param.map_id}/`, {}, (json) => {
                                        props.set(json.data.elements, param.map_id)
                                    });
                                })
                            } else {
                                alert('권한이 없습니다.');
                            }
                        } else {
                            props.open_login_dialog();
                        }
                    }
                });
            }
            return commands;
        }
    });
    cy.cxtmenu({
        selector: 'edge',
        commands: [
            {
                content: 'Delete',
                select: function (ele) {
                    console.log('edge delete')
                    if (is_my_map()) {
                        if (window.confirm('really?')) {
                            _delete(`/api/v1/seomalmap/${param.map_id}/edge/?edge_id=${ele.id()}`, {}, (result) => {
                                get(`/api/v1/seomalmap/${param.map_id}/`, {}, (json) => {
                                    props.set(json.data.elements, param.map_id)
                                });
                            })
                        }
                    } else {
                        props.open_login_dialog();
                    }


                }
            }
        ]
    });
    cy.cxtmenu({
        selector: 'core',
        commands: [
            {
                content: '지식 생성',
                select: function (e) {
                    if (is_login()) {
                        if (is_my_map() || is_public_write_map()) {
                            props.open_create_node('ROOT', null, cy.viewport().pan());
                        } else {
                            alert('권한이 없습니다.');
                        }
                    } else {
                        props.open_login_dialog();
                    }
                }
            },
            {
                content: '지식 그룹 생성',
                select: function (e) {
                    if (is_login()) {
                        if (is_my_map() || is_public_write_map()) {
                            props.open_create_group(null, cy.viewport().pan());
                        } else {
                            alert('권한이 없습니다.');
                        }
                    } else {
                        props.open_login_dialog();
                    }
                }
            }
        ]
    });
}

export function init(tapOverHandler, tapOutHandler, tabNodeHandler, tabHandler, param, props) {
    return (_cy) => {
        cy = _cy;
        // 랜더링 될 때마다 실행되기 때문에 아래 코드가 중복실행 됩니다. 그래서 1회만 실행되는 코드를 임시로 넣어두었습니다.
        pageRank = cy.elements().pageRank();
        if (props.selected_node.id !== null) {
            var _selected = cy.$('#' + props.selected_node.id);
            setResetFocus(cy);
            updateGroupVisibility(cy, props.selected_node.id);
            // [#151] 그룹은 opacity만으로 흐리게 표시되므로, 그룹이 아닌 노드/엣지도 색상은 그대로 두고
            // opacity만 dimOpacity로 낮춰야 둘의 흐려짐 정도가 동일하게 보인다. 예전에는 background-color 등을
            // dimColor(거의 흰색)로 함께 바꿔서 opacity가 같아도 그룹보다 훨씬 더 흐려 보였다.
            setStyle(cy, {
                'target-arrow-shape': 'triangle',
                'opacity': dimOpacity
            });
            if (_selected.isParent()) {
                // [node-parent-or 146][#151] 그룹(컴파운드) 노드를 선택하면 그 그룹과 소속 노드만 온전히 보이고
                // 관련 없는 다른 요소(다른 그룹 포함)는 dimOpacity로 흐리게 표시한다(완전히 숨기지 않음).
                // successors/predecessors 기반의 setFocus는 컴파운드 소속 관계를 보지 못하므로
                // 그룹 선택 시에는 별도로 처리한다.
                // [#151] 그룹 소속 노드(:child)는 setStyle과 동일한 이유로 여기서도 dim 대상에서 제외한다 —
                // 그룹 자체가 이미 dimOpacity로 흐려지므로, 소속 노드까지 개별로 흐리면 이중으로 옅어진다.
                cy.elements().not('node:child').style('opacity', dimOpacity);
                const groupAndChildren = _selected.union(_selected.descendants());
                const internalEdges = groupAndChildren.edgesWith(groupAndChildren);
                groupAndChildren.style('opacity', 1);
                groupAndChildren.style('color', fontColor);
                groupAndChildren.nodes().style('background-color', nodeBGColor);
                internalEdges.style('opacity', 1);
                internalEdges.style('line-color', edgeBGColor);
                internalEdges.style('target-arrow-color', edgeBGColor);
            } else {
                setFocus(cy, _selected, successorColor, predecessorsColor, edgeActiveWidth, arrowActiveScale);
                // [node-parent-or 145] 선택한 노드가 그룹에 속해 있으면, 그룹(컴파운드) 노드의 제목도
                // dimColor에서 복원한다. 컴파운드 소속 관계는 successors/predecessors/neighborhood
                // (엣지 기반)로는 잡히지 않기 때문에 별도로 처리해야 한다.
                _selected.ancestors().style('color', fontColor);
            }
            if (props.selected_node.is_need_animation) {
                cy.animate({
                    center: {eles: _selected},
                    zoom: 2
                }, {duration: 500})
            }
        } else {
            setResetFocus(cy);
            updateGroupVisibility(cy, null);
        }
        if (cy.isInit)
            return;
        if(param.node_id){
            props.select('N'+param.node_id, true);
        }
        window.cy = cy;
        let zoom = localStorage.getItem(`map_viewport_zoom_${param.map_id}`);
        let panX = localStorage.getItem(`map_viewport_pan_x_${param.map_id}`);
        let panY = localStorage.getItem(`map_viewport_pan_y_${param.map_id}`);
        if(panX === null && panY === null){
            cy.center();
        }
        if (zoom) {
            cy.zoom(Number(zoom));
        }
        if (panX && panY) {
            cy.pan({x: Number(panX), y: Number(panY)});
        }
        // if(localStorage.getItem(`map_viewport_${param.map_id}`))
        // 초기화가 되었는지 확인하기 위한 코드입니다.
        cy.isInit = true;
        cy.on('tapdragover', 'node', tapOverHandler);
        cy.on('tapdragout', 'node', tapOutHandler);
        cy.on('tap', 'node', tabNodeHandler);
        cy.on('tap', tabHandler);
        var home = getParameterByName('i');
        if (home) {
            var _home = cy.$('#' + home);
            setResetFocus(cy);
            setFocus(cy, _home, successorColor, predecessorsColor, edgeActiveWidth, arrowActiveScale);

            cy.animate({
                center: {eles: _home}
            }, {duration: 1500})
        } else {
            setResetFocus(cy);
        }


        function setStyle(target_cy, style) {
            // [#151] 그룹(:parent) 노드는 표시 여부를 updateGroupVisibility가 별도로 관리하므로 dim 대상에서 제외한다.
            // 그룹 소속 노드(:child)도 여기서 함께 dim 대상에 포함하면, 이미 흐려진 그룹 배경 위에
            // 노드 자신도 다시 흐려져 이중으로 옅어져 거의 안 보이게 된다. 그룹 소속 노드는 별도로
            // 스타일을 주지 않고 그룹 자체의 opacity만으로 흐려 보이게 한다.
            target_cy.nodes(':orphan').not(':parent').forEach(function (target) {
                target.style(style);
            });
            target_cy.edges().forEach(function (target) {
                target.style(style);
            });

        }

        // [#138] 드래그로 옮긴 위치가 어떤 그룹(compound node)의 bounding box 안에 들어왔는지 판정한다.
        // - 이동한 노드가 이미 속한 그룹의 bounding box를 벗어나지 않았다면 아무 것도 묻지 않는다.
        // - 새 위치가 자신이 속하지 않은 다른 그룹의 bounding box 안이라면 편입 여부 확인 다이얼로그를 띄운다.
        function findGroupToConfirm(ele, pos) {
            if (ele.isParent()) {
                // 그룹 노드 자체를 다른 그룹의 하위로 편입시키는 것은 이 기능의 대상이 아니다.
                return null;
            }
            const currentParent = ele.parent();
            const currentParentId = currentParent.nonempty() ? currentParent.id() : null;

            if (currentParentId) {
                // [node-parent-or 138 수정] compound 노드의 bounding box는 정의상 "현재 자식들의 위치"를
                // 실시간으로 감싸도록 계산되기 때문에, 방금 옮긴 ele 자신을 포함해서 계산하면
                // ele가 어디로 움직이든 항상 "자기 그룹 박스 안"으로 판정되는 항진명제가 되어버린다
                // (그룹에 형제가 하나도 없는 경우는 더 심해서, 박스 자체가 ele 위치를 그대로 따라간다).
                // 그래서 ele를 제외한 형제들만으로 박스를 계산해 "형제들이 차지하던 영역을 벗어났는가"를 봐야 한다.
                const siblings = currentParent.children().not(ele);
                if (siblings.nonempty()) {
                    const bb = siblings.boundingBox();
                    if (pos.x >= bb.x1 && pos.x <= bb.x2 && pos.y >= bb.y1 && pos.y <= bb.y2) {
                        // 형제 노드들이 차지한 영역 안에 그대로 있다 = 그룹을 벗어나지 않았다.
                        return null;
                    }
                }
                // 형제가 없으면(그룹의 유일한 멤버였던 경우) "그대로 있다"를 판단할 기준이 없으므로
                // 아래에서 다른 그룹의 후보 여부만으로 판정한다.
            }

            const candidates = ele.cy().nodes(':parent').filter((group) => {
                if (group.id() === currentParentId) return false;
                if (group.same(ele)) return false;
                const bb = group.boundingBox();
                return pos.x >= bb.x1 && pos.x <= bb.x2 && pos.y >= bb.y1 && pos.y <= bb.y2;
            });
            return candidates.length > 0 ? candidates[0] : null;
        }

        cy.on('tapstart tapend', 'node', (e) => {
            if (is_my_map()) {
                if (e.type === 'tapstart') {
                    let pos = e.target.position();
                    e.target._prevPosition = {x: pos.x, y: pos.y}
                }
                if (e.type === 'tapend') {
                    let ele = e.target;
                    let prevPos = ele._prevPosition;
                    let pos = ele.position();
                    if (prevPos.x !== pos.x || prevPos.y !== pos.y) {
                        patch(`/api/v1/node/${ele.id().substr(1)}/`, {
                            x: pos.x,
                            y: pos.y
                        }, () => {
                        })
                        const group = findGroupToConfirm(ele, pos);
                        if (group) {
                            props.open_group_join_confirm(ele.id(), group.id(), group.data('label') || group.id());
                        }
                    }
                }
            }
            props.select(e.target.id(), false);
            props.close_tooltip();
        })
        cy.on('mouseout', 'node', function (e) {
            // debugger;
            // document.querySelector('#msg').value += (e.type)+"\n";
            // props.select(null);
        });
        cy.on('viewport', (e) => {
            localStorage.setItem(`map_viewport_zoom_${param.map_id}`, cy.zoom());
            localStorage.setItem(`map_viewport_pan_x_${param.map_id}`, cy.pan().x);
            localStorage.setItem(`map_viewport_pan_y_${param.map_id}`, cy.pan().y);
            props.close_tooltip();
        })

        cy.on('mouseover', 'node', function (e) {
            // props.select(e.target.id(), false);
            // props.close_tooltip();
        });

        if(isBeta()) {
            applyContextMenu(param, props);
        }

        cy.on("tapstart cxttapstart", function (e) {
            // 마지막으로 탭 한 position을 기록합니다.
            props.set_tab_position(e.position);
        });
    };
}

var pageRank = null;
var cy = null;
